import React, { useReducer, useEffect, useRef, useCallback } from 'react';
import {
  Flex,
  FormControl,
  FormLabel,
  Input,
  Button,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Box,
  useDisclosure,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerOverlay,
  DrawerCloseButton,
  DrawerHeader,
  Stack,
  DrawerFooter,
  Select,
  useToast,
} from '@chakra-ui/react';
import JoditEditor from 'jodit-react';
import { AddIcon, EditIcon, DeleteIcon } from '@chakra-ui/icons';
import SavingPlanVariantApi from 'api/savingplanvariant';
import { v4 as uuidv4 } from 'uuid';
import PopDelete from './deletePopOver';
function editorReducer(state, action) {
  switch (action.type) {
    case 'SET_DATA':
      return {
        ...state,
        allData: action.payload,
        editorsData: action.languageData,
      };
    case 'EDIT_ITEM':
      return { ...state, selectedItem: action.payload, isEditMode: true };
    case 'NEW_ITEM':
      return {
        ...state,
        selectedItem: { heading: '', body: '' },
        isEditMode: false,
      };
    case 'UPDATE_ITEM':
      return {
        ...state,
        selectedItem: {
          ...state.selectedItem,
          [action.payload.field]: action.payload.value,
        },
      };
    case 'RESET':
      return {
        ...state,
        selectedItem: null,
        isEditMode: false,
        headingError: null,
        bodyError: null,
      };
    case 'SET_ERROR':
      return {
        ...state,
        headingError:
          action.payload.field === 'heading'
            ? action.payload.message
            : state.headingError,
        bodyError:
          action.payload.field === 'body'
            ? action.payload.message
            : state.bodyError,
      };
    case 'SET_LANGUAGE':
      return {
        ...state,
        language: action.payload,
        editorsData: action.languageData || [],
      };
    default:
      return state;
  }
}
const initialState = {
  editorsData: [],
  selectedItem: null,
  isEditMode: false,
  headingError: null,
  bodyError: null,
  language: 'en',
};

export default function ContentForm() {
  const [state, dispatch] = useReducer(editorReducer, initialState);
  const toast = useToast();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const initialRef = useRef(null);
  const errorRef = useRef(null);
  const { editorsData = [] } = state;

  const id = IdFromUrl(window.location.href);
  function IdFromUrl(url) {
    const parts = url.split('/');
    const id = parts[parts.length - 1];
    return id;
  }

  const fetchLanguageData = async (lang) => {
    let response = await SavingPlanVariantApi.getById(id);
    response = response.data;
    const allData = response?.data?.details || {};
    console.log('language darta', lang, response?.data?.details);
    const languageData = response?.data?.details
      ? response?.data?.details[`${lang}`]
      : [];
    dispatch({
      type: 'SET_DATA',
      payload: allData,
      languageData,
    });
  };

  // useEffect(() => {
  //   async function fetchData() {
  //     console.log('Id fetched here', id);
  //     let response = await SavingPlanVariantApi.getById(id);
  //     response = response.data;
  //     dispatch({
  //       type: 'SET_DATA',
  //       payload: response?.data?.details?.en || [],
  //     });
  //   }
  //   fetchData();
  // }, [id]);

  useEffect(() => {
    // Fetch default language data (English) on component mount
    fetchLanguageData('en');
  }, []);

  const handleLanguageChange = (e) => {
    const selectedLanguage = e.target.value;
    const languageData = state.allData[selectedLanguage] || [];
    dispatch({ type: 'SET_LANGUAGE', payload: selectedLanguage, languageData });
  };

  const handleEditorChange = useCallback((item) => {
    dispatch({ type: 'EDIT_ITEM', payload: item });
    onOpen();
  }, []);

  const handleDelete = async (selectedKey) => {
    const updatedData = state.allData[state.language].filter(
      (item) => item.key !== selectedKey
    );

    const newAllData = {
      ...state.allData,
      [state.language]: [...updatedData],
    };

    dispatch({
      type: 'SET_DATA',
      payload: newAllData,
      languageData: updatedData,
    });

    try {
      await SavingPlanVariantApi.Update({
        id,
        newDetail: newAllData,
      });
      toast({
        title: 'Item deleted successfully.',
        status: 'success',
        duration: 5000,
        isClosable: true,
        position: 'top',
      });
    } catch (error) {
      console.error('Error deleting:', error);
      dispatch({
        type: 'SET_DATA',
        payload: state.allData, // Revert state on failure
      });
      toast({
        title: 'Error deleting item.',
        description: error.message || 'Please try again later.',
        status: 'error',
        duration: 5000,
        isClosable: true,
        position: 'top',
      });
    }
  };

  const openNewSectionDrawer = () => {
    dispatch({ type: 'RESET' });
    dispatch({ type: 'NEW_ITEM' });
    onOpen();
  };

  const saveSection = async () => {
    const { selectedItem, editorsData, isEditMode } = state;

    // Check if heading and body are provided
    if (!selectedItem || !selectedItem.heading || !selectedItem.body) {
      dispatch({
        type: 'SET_ERROR',
        payload: {
          field: !selectedItem
            ? ''
            : !selectedItem.heading
              ? 'heading'
              : 'body',
          message: 'This field is required.',
        },
      });
      return;
    }
    const position = editorsData?.findIndex(
      (item) => item.key === selectedItem.key
    );
    console.log('Index', position, editorsData);
    let updatedData;
    console.log('selected item', selectedItem);
    const existingItem = editorsData.find(
      (item, index) =>
        item.heading.toLowerCase() === selectedItem.heading.toLowerCase() &&
        index !== position
    );

    console.log('ExistingItem', existingItem);
    if (existingItem) {
      dispatch({
        type: 'SET_ERROR',
        payload: { field: 'heading', message: 'Heading must be unique.' },
      });
      return;
    }

    if (position >= 0) {
      if (isEditMode) {
        console.log('ISEditMode', position, selectedItem);
        updatedData = editorsData.map((item) =>
          item.key === selectedItem.key
            ? {
              ...item,
              body: selectedItem.body,
              heading: selectedItem.heading,
            }
            : item
        );
      }
    } else {
      // Add a new section with unique key
      const newKey = uuidv4();
      updatedData = [...editorsData, { ...selectedItem, key: newKey }];
    }
    const newAllData = {
      ...state.allData,
      [state.language]: updatedData, // Update only the current language data
    };

    dispatch({
      type: 'SET_DATA',
      payload: newAllData,
      languageData: updatedData,
    });
    try {
      let response = await SavingPlanVariantApi.Update({
        id,
        newDetail: newAllData,
      });

      response = response.data;

      if (response.status_code === 200) {
        toast({
          title: response.message || 'Successfully Added',
          status: 'success',
          duration: 5000,
          isClosable: true,
          position: 'top',
        });
        onClose();
      } else {
        toast({
          title: response.message || 'Error Adding',
          status: 'error',
          duration: 5000,
          isClosable: true,
          position: 'top',
        });
      }
    } catch (err) {
      console.log(err);

      toast({
        title: 'Error Updating',
        status: 'error',
        duration: 5000,
        isClosable: true,
        position: 'top',
      });
    }

    dispatch({ type: 'RESET' });
  };
  function sanitizeContent(content) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(content, 'text/html');
    doc.querySelectorAll('table').forEach((table) => {
      table.style.borderCollapse = 'collapse';
      table.style.width = '100%';
      table.style.border = '1px solid black';
    });
    doc.querySelectorAll('td').forEach((td) => {
      td.style.border = '1px solid black';
    });
    return doc.body.innerHTML;
  }

  return (
    <Flex direction='column'>
      <FormControl>
        <FormLabel>Select Language</FormLabel>
        <Select value={state.language} onChange={handleLanguageChange}>
          <option value='en'>English</option>
          <option value='kn'>Kannada</option>
        </Select>
      </FormControl>

      <Box width='100%' mt={10} mb={10}>
        <Accordion allowToggle allowMultiple={true}>
          {state.editorsData &&
            editorsData.map((item, index) => (
              <AccordionItem
                bgColor='gray.105'
                border='1px'
                borderBottom='1px solid secondaryGray.300'
                borderColor='secondaryGray.300'
                borderRadius={8}
                key={index}
                mb={1}
              >
                <h2>
                  <AccordionButton
                    _focus={{
                      outline: 'none',
                      boxShadow: 'none',
                    }}
                  >
                    <Box flex='1' textAlign='left'>
                      {item.heading}
                    </Box>
                    <AccordionIcon />
                  </AccordionButton>
                </h2>
                {console.log('Item', item.body)}
                <AccordionPanel bgColor='white' borderRadius={8}>
                  <Flex justifyContent='space-between'>
                    <div
                      pb={4}
                      key={index}
                      bgColor='white'
                      dangerouslySetInnerHTML={{
                        __html: item.body,
                      }}
                    />
                  </Flex>
                  <Flex justifyContent='flex-end'>
                    <Button
                      p={0}
                      mt={4}
                      onClick={() => handleEditorChange(item)}
                    >
                      <EditIcon />
                    </Button>
                    <PopDelete
                      Icon={<DeleteIcon />}
                      button={
                        <Button
                          colorScheme='red'
                          onClick={() => handleDelete(item.key)}
                        >
                          Delete
                        </Button>
                      }
                    ></PopDelete>
                    {/* <Button>
                     <DeleteIcon />
                   </Button> */}
                  </Flex>
                </AccordionPanel>
              </AccordionItem>
            ))}
        </Accordion>
        <Button
          width='100%'
          mt={4}
          leftIcon={<AddIcon />}
          colorScheme='blue'
          borderRadius={8}
          onClick={openNewSectionDrawer}
        >
          Add New Section
        </Button>
      </Box>

      <Drawer
        isOpen={isOpen}
        placement='right'
        onClose={onClose}
        initialFocusRef={initialRef}
        size='lg'
      >
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader>
            {state.isEditMode ? 'Edit Section' : 'Add New Section'}
          </DrawerHeader>

          <DrawerBody>
            <Stack spacing='24px'>
              <FormControl>
                <FormLabel htmlFor='heading'>Heading</FormLabel>
                <Input
                  id='heading'
                  ref={initialRef}
                  value={state.selectedItem ? state.selectedItem.heading : ''}
                  onChange={(e) =>
                    dispatch({
                      type: 'UPDATE_ITEM',
                      payload: { field: 'heading', value: e.target.value },
                    })
                  }
                />
                {state.headingError && (
                  <Box color='red.500' mt={2}>
                    {state.headingError}
                  </Box>
                )}
              </FormControl>
              <FormControl>
                <FormLabel htmlFor='body'>Body</FormLabel>
                {state.bodyError && (
                  <Box color='red.500' mt={2}>
                    {state.bodyError}
                  </Box>
                )}
                <JoditEditor
                  value={state.selectedItem ? state.selectedItem.body : ''}
                  onChange={(content) =>
                    dispatch({
                      type: 'UPDATE_ITEM',
                      payload: {
                        field: 'body',
                        value: sanitizeContent(content),
                      },
                    })
                  }
                />
              </FormControl>
            </Stack>
          </DrawerBody>

          <DrawerFooter>
            <Button variant='outline' mr={3} onClick={onClose}>
              Cancel
            </Button>
            <Button colorScheme='blue' onClick={saveSection}>
              Save
            </Button>
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
    </Flex>
  );
}
